<template>
  <div>
    <v-layout row wrap :class="groupedChartData && groupedChartData.length == 3 ? '':'px-5'">
      <v-flex xs12>
        <h3>{{title}}</h3>
      </v-flex>
      <template v-if="groupedChartData && groupedChartData.length == 1">
        <v-flex xs12 v-for="(chart,index) in groupedChartData" :key="index">
          <pieChart :chartData="chart" :title="chart[0].groupBy"></pieChart>
        </v-flex>
      </template>
      <template v-else-if="groupedChartData && groupedChartData.length == 2">
        <v-flex xs12 md6 v-for="(chart,index) in groupedChartData" :key="index">
          <pieChart :chartData="chart" :title="chart[0].groupBy"></pieChart>
        </v-flex>
      </template>
      <template v-else>
        <v-flex xs12 md4 v-for="(chart,index) in groupedChartData" :key="index">
          <pieChart :chartData="chart" :title="chart[0].groupBy"></pieChart>
        </v-flex>
      </template>
    </v-layout>
  </div>
</template>

<script>
import pieChart from "../../Chart1/PieChart/PieChart";
export default {
  components: {
    pieChart
  },
  props: {
    chartData: {
      type: Array
    },
    title: {
      type: String,
      default: () => {
        return "";
      }
    }
  },
  data: function() {
    return {
      groupedChartData: []
    };
  },
  mounted() {
    this.getGroupedChartData(this.chartData);
  },
  methods: {
    getGroupedChartData(chartData) {
      this.groupedChartData = [];
      let context = this;
      var groupByItems = [...new Set(chartData.map(x => x.groupBy))];
      groupByItems.forEach(group => {
        context.groupedChartData.push(
          chartData.filter(x => x.groupBy == group)
        );
      });
    }
  },
  watch: {
    chartData(newValue, OldValue) {
   
      // console.log(JSON.stringify(newValue))
      if (newValue) {
        this.getGroupedChartData(newValue);
      }
    }
  }
};
</script>